module.exports = __webpack_public_path__ + "img/CersoTearsInkBlue.da75fc5d.png";